module.exports = __webpack_public_path__ + "img/73800.76bb3802.jpg";